export const backToBasic = {

	"title": "BACK to BASIC",
	"subtitle": "COLLECTION",
	"descriptionITA": "La nostra linea sartoriale realizzata su canape naturali e lavorate a telaio in italia",
    "descriptionENG": "Our sartorial line made on natural hems and loomed in Italy",

};
export const royalGarden = {

    "title": "ROYAL GARDEN",
    "subtitle": "COLLECTION",
    "descriptionITA": "Stampa floreale impressa sui luminosi lini bianchi ispirati ai giardini floreali francesi",
    "descriptionENG": "Floral print imprinted on bright white linens inspired by French floral gardens"

};
export const cashmereFeelings = {

    "title": "CASHMERE FEELINGS",
    "subtitle": "COLLECTION",
    "descriptionITA": "Garze naturali, colori terra e stampe cashmere realizzate su fibre naturali di lino garzato",
    "descriptionENG": "Natural gauze, earth colors and cashmere prints made on natural brushed linen fibers"

};
export const antiqueLace = {

    "title": "ANTIQUE LACE",
    "subtitle": "COLLECTION",
    "descriptionITA": "Pizzi ispirati alle antiche arti artigianali italiane",
    "descriptionENG": "Lace inspired by the ancient Italian artisan arts"

};
export const greenTouch = {

    "title": "GREECE TOUCH",
    "subtitle": "COLLECTION",
    "descriptionITA": "I nostri lini ricamati con le antiche arti artigianali dell'uncinetto e ispirati alle muse greche",
    "descriptionENG": "Our linens embroidered with the ancient artisan arts of crochet and inspired by the Greek muses"

};


export const backToBasicProducts = [
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-036.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-036-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-036-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-036-retro-min.jpg",

        "prod1": "GIACCA SANGIOVESE",
        "stile1": "JEANS",
        "taglia1": "TAGLIA SML",

        "prod2": "TOP FIANO",
        "stile2": "JEANS",
        "taglia2": "TAGLIA SML",

        "prod3": "PANTALONE KRUG",
        "stile3": "JEANS",
        "taglia3": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-053.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-053-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-053-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-053-retro-min.jpg",
        "prod1": "ABITO RIBOLLA",
        "stile1": "JEANS",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-061.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-061-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-061-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-061-retro-min.jpg",
        "prod1": "CAMICIA CERVARO",
        "stile1": "JEANS",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE MARTE",
        "stile2": "JEANS",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-080.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-080-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-080-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-080-retro-min.jpg",
        "prod1": "CAMICIA PINOT",
        "stile1": "JEANS",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE OLYMPIA",
        "stile2": "JEANS",
        "taglia2": "TAGLIA SMLXL",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-092.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-092-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-092-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-092-retro-min.jpg",
        "prod1": "ABITO MEMORY",
        "stile1": "JEANS",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-101.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-101-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-101-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-101-retro-min.jpg",
        "prod1": "TUTA MOSCATO",
        "stile1": "JEANS",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-112.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-112-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-112-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-112-retro-min.jpg",
        "prod1": "CASACCA BAROLO",
        "stile1": "JEANS",
        "taglia1": "TAGLIA UNICA",

        "prod2": "PANTALONE MARTE",
        "stile2": "JEANS",
        "taglia2": "TAGLIA SMLXL",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-127.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-127-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-127-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-127-retro-min.jpg",
        "prod1": "CASACCA SCHIAVA",
        "stile1": "JEANS",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE RIESLING",
        "stile2": "JEANS",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-147.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-147-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-147-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-147-retro-min.jpg",
        "prod1": "ABITO AGLIANICO",
        "stile1": "JEANS",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-156.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-156-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-156-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-156-retro-min.jpg",
        "prod1": "TOP FALANGHINA",
        "stile1": "JEANS",
        "taglia1": "TAGLIA SML",

        "prod2": "SHORT GRECO",
        "stile2": "JEANS",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-165.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-165-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-165-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-165-retro-min.jpg",
        "prod1": "ABITO TIRRENO",
        "stile1": "JEANS",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-211.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-211-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-211-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-211-retro-min.jpg",
        "prod1": "ABITO LAGRAIN",
        "stile1": "JEANS",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-227.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-227-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-227-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-227-retro-min.jpg",
        "prod1": "ABITO DOLCETTO",
        "stile1": "JEANS",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-240.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-240-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-240-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-240-retro-min.jpg",
        "prod1": "ABITO CHABLIS",
        "stile1": "JEANS",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-257.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-257-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-257-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-257-retro-min.jpg",
        "prod1": "ABITO PROSECCO",
        "stile1": "JEANS",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-285.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-285-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-285-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-285-retro-min.jpg",
        "prod1": "CASACCA BLOOD",
        "stile1": "JEANS",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE NEBBIOLO",
        "stile2": "JEANS",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-304.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-304-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-304-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-304-retro-min.jpg",
        "prod1": "CAMICIA PRIMITIVO",
        "stile1": "JEANS",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE MARTE",
        "stile2": "JEANS",
        "taglia2": "TAGLIA SMLXL",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-529.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-529-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-529-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-529-retro-min.jpg",
        "prod1": "CASACCA BLOOD",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE NEBBIOLO",
        "stile2": "BIANCO",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-551.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-551-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-551-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-551-retro-min.jpg",
        "prod1": "ABITO PROSECCO",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-568.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-568-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-568-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-568-retro-min.jpg",
        "prod1": "ABITO CHABLIS",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-583.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-583-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-583-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-583-retro-min.jpg",
        "prod1": "ABITO LAGRAIN",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-592.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-592-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-592-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-592-retro-min.jpg",
        "prod1": "ABITO TIRRENO",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-619.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-619-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-619-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-619-retro-min.jpg",
        "prod1": "TOP FALANGHINA",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA SML",

        "prod2": "SHORT GRECO",
        "stile2": "BIANCO",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-640.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-640-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-640-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-640-retro-min.jpg",
        "prod1": "ABITO AGLIANICO",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-658.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-658-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-658-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-658-retro-min.jpg",
        "prod1": "ABITO DOLCETTO",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-684.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-684-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-684-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-684-retro-min.jpg",
        "prod1": "ABITO MEMORY",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-696.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-696-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-696-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-696-retro-min.jpg",
        "prod1": "ABITO RIBOLLA",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-707.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-707-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-707-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-707-retro-min.jpg",
        "prod1": "CAMICIA PINOT",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA SML",

        "prod2": "GONNA BRACHETTO",
        "stile2": "BIANCO",
        "taglia2": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-723.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-723-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-723-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-723-retro-min.jpg",
        "prod1": "CAMICIA CERVARO",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE MARTE",
        "stile2": "BIANCO",
        "taglia2": "TAGLIA SMLXL",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-731.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-731-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-731-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-731-retro-min.jpg",
        "prod1": "CASACCA BAROLO",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA UNICA",

        "prod2": "SHORT SISMA",
        "stile2": "BIANCO",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-746.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-746-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-746-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-746-retro-min.jpg",
        "prod1": "TUTA MOSCATO",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-756.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-756-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-756-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-756-retro-min.jpg",
        "prod1": "CAMICIA PRIMITIVO",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA SML",

        "prod2": "SHORT SISMA",
        "stile2": "BIANCO",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-769.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-769-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-769-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-769-retro-min.jpg",
        "prod1": "CASACCA SCHIAVA",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE RIESLING",
        "stile2": "BIANCO",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-779.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-779-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-779-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-779-retro-min.jpg",
        "prod1": "GIACCA SANGIOVESE",
        "stile1": "ECRU",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE KRUG",
        "stile2": "ECRU",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-790.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-790-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-790-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-790-retro-min.jpg",
        "prod1": "ABITO DOLCETTO",
        "stile1": "ECRU",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-818.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-818-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-818-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-818-retro-min.jpg",
        "prod1": "ABITO CHABLIS",
        "stile1": "ECRU",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-835.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-835-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-835-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-835-retro-min.jpg",
        "prod1": "ABITO PROSECCO",
        "stile1": "ECRU",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-859.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-859-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-859-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-859-retro-min.jpg",
        "prod1": "ABITO LAGRAIN",
        "stile1": "ECRU",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-870.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-870-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-870-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-870-retro-min.jpg",
        "prod1": "ABITO TIRRENO",
        "stile1": "ECRU",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-879.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-879-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-879-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-879-retro-min.jpg",
        "prod1": "ABITO AGLIANICO",
        "stile1": "ECRU",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-886.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-886-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-886-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-886-retro-min.jpg",
        "prod1": "ABITO RIBOLLA",
        "stile1": "ECRU",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-903.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-903-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-903-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-903-retro-min.jpg",
        "prod1": "ABITO MOSCATO",
        "stile1": "ECRU",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-917.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-917-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-917-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-917-retro-min.jpg",
        "prod1": "TOP FALANGHINA",
        "stile1": "ECRU",
        "taglia1": "TAGLIA SML",

        "prod2": "SHORT GRECO",
        "stile2": "ECRU",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-933.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-933-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-933-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-933-retro-min.jpg",
        "prod1": "CASACCA SCHIAVA",
        "stile1": "ECRU",
        "taglia1": "TAGLIA SML",

        "prod2": "GONNA BRACHETTO",
        "stile2": "ECRU",
        "taglia2": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-949.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-949-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-949-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-949-retro-min.jpg",
        "prod1": "CASACCA BAROLO",
        "stile1": "ECRU",
        "taglia1": "TAGLIA UNICA",

        "prod2": "SHORT GRECO",
        "stile2": "ECRU",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-964.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-964-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-964-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-964-retro-min.jpg",
        "prod1": "CAMICIA PINOT",
        "stile1": "ECRU",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE NEBBIOLO",
        "stile2": "ECRU",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-976.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-976-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-976-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-976-retro-min.jpg",
        "prod1": "CAMICIA PRIMITIVO",
        "stile1": "ECRU",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE MARTE",
        "stile2": "ECRU",
        "taglia2": "TAGLIA SMLXL",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/1_backToBasic/BLITZ POSITANO-988.jpg",
        "retro": "lookbook1/1_backToBasic/BLITZ POSITANO-988-retro.jpg",
        "photomin": "lookbook1/1_backToBasic/BLITZ POSITANO-988-min.jpg",
        "retromin": "lookbook1/1_backToBasic/BLITZ POSITANO-988-retro-min.jpg",

        "prod1": "CAMICIA CERVARO",
        "stile1": "ECRU",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE MARTE",
        "stile2": "ECRU",
        "taglia2": "TAGLIA SMLXL",

        "colori": "+COLOUR"
    },

];
export const royalGardenProducts = [
    {
        "photo": "lookbook1/2_royalGarden/BLITZ POSITANO-353.jpg",
        "retro": "lookbook1/2_royalGarden/BLITZ POSITANO-353-retro.jpg",
        "photomin": "lookbook1/2_royalGarden/BLITZ POSITANO-353-min.jpg",
        "retromin": "lookbook1/2_royalGarden/BLITZ POSITANO-353-retro-min.jpg",
        "prod1": "ABITO MEMORY",
        "stile1": "S.FLOWER",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/2_royalGarden/BLITZ POSITANO-366.jpg",
        "retro": "lookbook1/2_royalGarden/BLITZ POSITANO-366-retro.jpg",
        "photomin": "lookbook1/2_royalGarden/BLITZ POSITANO-366-min.jpg",
        "retromin": "lookbook1/2_royalGarden/BLITZ POSITANO-366-retro-min.jpg",
        "prod1": "ABITO CHABLIS",
        "stile1": "S.FLOWER",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/2_royalGarden/BLITZ POSITANO-398.jpg",
        "retro": "lookbook1/2_royalGarden/BLITZ POSITANO-398-retro.jpg",
        "photomin": "lookbook1/2_royalGarden/BLITZ POSITANO-398-min.jpg",
        "retromin": "lookbook1/2_royalGarden/BLITZ POSITANO-398-retro-min.jpg",
        "prod1": "ABITO TIRRENO",
        "stile1": "S.FLOWER",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/2_royalGarden/BLITZ POSITANO-384.jpg",
        "retro": "lookbook1/2_royalGarden/BLITZ POSITANO-384-retro.jpg",
        "photomin": "lookbook1/2_royalGarden/BLITZ POSITANO-384-min.jpg",
        "retromin": "lookbook1/2_royalGarden/BLITZ POSITANO-384-retro-min.jpg",
        "prod1": "ABITO LAGRAIN",
        "stile1": "S.FLOWER",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/2_royalGarden/BLITZ POSITANO-419.jpg",
        "retro": "lookbook1/2_royalGarden/BLITZ POSITANO-419-retro.jpg",
        "photomin": "lookbook1/2_royalGarden/BLITZ POSITANO-419-min.jpg",
        "retromin": "lookbook1/2_royalGarden/BLITZ POSITANO-419-retro-min.jpg",
        "prod1": "ABITO PROSECCO",
        "stile1": "S.FLOWER",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/2_royalGarden/BLITZ POSITANO-435.jpg",
        "retro": "lookbook1/2_royalGarden/BLITZ POSITANO-435-retro.jpg",
        "photomin": "lookbook1/2_royalGarden/BLITZ POSITANO-435-min.jpg",
        "retromin": "lookbook1/2_royalGarden/BLITZ POSITANO-435-retro-min.jpg",
        "prod1": "GIACCA SANGIOVESE",
        "stile1": "S.FLOWER",
        "taglia1": "TAGLIA SML",

        "prod2": "GONNA VERMENTINO",
        "stile2": "S.FLOWER",
        "taglia2": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/2_royalGarden/BLITZ POSITANO-447.jpg",
        "retro": "lookbook1/2_royalGarden/BLITZ POSITANO-447-retro.jpg",
        "photomin": "lookbook1/2_royalGarden/BLITZ POSITANO-447-min.jpg",
        "retromin": "lookbook1/2_royalGarden/BLITZ POSITANO-447-retro-min.jpg",
        "prod1": "CASACCA SUMMER",
        "stile1": "S.FLOWER",
        "taglia1": "TAGLIA UNICA",

        "prod2": "PANTALONE MARTE",
        "stile2": "S.FLOWER",
        "taglia2": "TAGLIA S",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/2_royalGarden/BLITZ POSITANO-465.jpg",
        "retro": "lookbook1/2_royalGarden/BLITZ POSITANO-465-retro.jpg",
        "photomin": "lookbook1/2_royalGarden/BLITZ POSITANO-465-min.jpg",
        "retromin": "lookbook1/2_royalGarden/BLITZ POSITANO-465-retro-min.jpg",
        "prod1": "CAMICIA PINOT",
        "stile1": "S.FLOWER",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE RIESLING",
        "stile2": "S.FLOWER",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/2_royalGarden/BLITZ POSITANO-479.jpg",
        "retro": "lookbook1/2_royalGarden/BLITZ POSITANO-479-retro.jpg",
        "photomin": "lookbook1/2_royalGarden/BLITZ POSITANO-479-min.jpg",
        "retromin": "lookbook1/2_royalGarden/BLITZ POSITANO-479-retro-min.jpg",
        "prod1": "CAMICIA TREBBIANO",
        "stile1": "S.FLOWER",
        "taglia1": "TAGLIA UNICA",

        "prod2": "PANTALONE RIESLING",
        "stile2": "BIANCO",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/2_royalGarden/BLITZ POSITANO-507.jpg",
        "retro": "lookbook1/2_royalGarden/BLITZ POSITANO-507-retro.jpg",
        "photomin": "lookbook1/2_royalGarden/BLITZ POSITANO-507-min.jpg",
        "retromin": "lookbook1/2_royalGarden/BLITZ POSITANO-507-retro-min.jpg",
        "prod1": "TOP MELODIA",
        "stile1": "S.FLOWER",
        "taglia1": "TAGLIA UNICA",

        "prod2": "PANTALONE KRUG",
        "stile2": "BIANCO",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/2_royalGarden/BLITZ POSITANO-318.jpg",
        "retro": "lookbook1/2_royalGarden/BLITZ POSITANO-318-retro.jpg",
        "photomin": "lookbook1/2_royalGarden/BLITZ POSITANO-318-min.jpg",
        "retromin": "lookbook1/2_royalGarden/BLITZ POSITANO-318-retro-min.jpg",
        "prod1": "ABITO DOLCETTO",
        "stile1": "S.FLOWER",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/2_royalGarden/BLITZ POSITANO-341.jpg",
        "retro": "lookbook1/2_royalGarden/BLITZ POSITANO-341-retro.jpg",
        "photomin": "lookbook1/2_royalGarden/BLITZ POSITANO-341-min.jpg",
        "retromin": "lookbook1/2_royalGarden/BLITZ POSITANO-341-retro-min.jpg",
        "prod1": "ABITO NINA",
        "stile1": "S.FLOWER",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    }
];
export const cashmereFeelingsProducts = [
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1099.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1099-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1099-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1099-retro-min.jpg",
        "prod1": "CAMICIA TREBBIANO",
        "stile1": "PANNA",
        "taglia1": "TAGLIA UNICA",

        "prod2": "PANTALONE MUSA",
        "stile2": "PANNA",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1109.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1109-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1109-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1109-retro-min.jpg",
        "prod1": "ABITO FERNANDA",
        "stile1": "PANNA",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1139.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1139-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1139-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1139-retro-min.jpg",
        "prod1": "CAMICIA APSARA",
        "stile1": "CREAM",
        "taglia1": "TAGLIA UNICA",

        "prod2": "PANTALONE MUSA",
        "stile2": "CREAM",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1164.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1164-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1164-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1164-retro-min.jpg",
        "prod1": "SPOLVERINO MARBELLA",
        "stile1": "CREAM",
        "taglia1": "TAGLIA UNICA",

        "prod2": "TUTA NADA",
        "stile2": "CREAM",
        "taglia2": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1178.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1178-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1178-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1178-retro-min.jpg",
        "prod1": "SPOLVERINO LUCE ",
        "stile1": "PANNA",
        "taglia1": "TAGLIA UNICA",

        "prod2": "TUTA GRAPPA",
        "stile2": "PANNA",
        "taglia2": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1191.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1191-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1191-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1191-retro-min.jpg",
        "prod1": "GIACCA PRESTIGE",
        "stile1": "PANNA",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE MUSA",
        "stile2": "PANNA",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1158.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1158-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1158-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1158-retro-min.jpg",
        "prod1": "ABITO RITZ",
        "stile1": "ECRU",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1072.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1072-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1072-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1072-retro-min.jpg",
        "prod1": "ABITO KONO",
        "stile1": "CAPPUCCINO",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1000.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1000-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1000-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1000-retro-min.jpg",
        "prod1": "ABITO PLAZA",
        "stile1": "CAPPUCCINO",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1031.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1031-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1031-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1031-retro-min.jpg",
        "prod1": "ABITO ROXY",
        "stile1": "CAPPUCCINO",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1063.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1063-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1063-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1063-retro-min.jpg",
        "prod1": "ABITO LAGRAIN",
        "stile1": "ST.CASHMERE",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1087.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1087-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1087-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1087-retro-min.jpg",
        "prod1": "ABITO LANGOSTA",
        "stile1": "ST.CASHMERE",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1015.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1015-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1015-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1015-retro-min.jpg",
        "prod1": "ABITO EGITTO",
        "stile1": "ST.CASHMERE",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1054.jpg",
        "retro": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1054-retro.jpg",
        "photomin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1054-min.jpg",
        "retromin": "lookbook1/3_cashmereFeelings/BLITZ POSITANO-1054-retro-min.jpg",
        "prod1": "ABITO MEMORY",
        "stile1": "ST.CASHMERE",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    }
];
export const antiqueLaceProducts = [
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1226.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1226-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1226-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1226-retro-min.jpg",
        "prod1": "CAMICIA PRIMITIVO",
        "stile1": "PIZZO BIANCO",
        "taglia1": "TAGLIA SML",

        "prod2": "SHORT LINDO",
        "stile2": "PIZZO BIANCO",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1245.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1245-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1245-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1245-retro-min.jpg",
        "prod1": "ABITO CHABLIS",
        "stile1": "PIZZO BIANCO",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1201.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1201-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1201-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1201-retro-min.jpg",
        "prod1": "CAMICIA NIRVANA",
        "stile1": "PIZZO BIANCO",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE KRUG",
        "stile2": "PIZZO BIANCO",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1217.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1217-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1217-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1217-retro-min.jpg",
        "prod1": "ABITO CORVINA",
        "stile1": "PIZZO BIANCO",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1297.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1297-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1297-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1297-retro-min.jpg",
        "prod1": "TUTA ERCOLE",
        "stile1": "PIZZO BIANCO",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1265.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1265-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1265-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1265-retro-min.jpg",
        "prod1": "ABITO DOLCETTO",
        "stile1": "PIZZO BIANCO",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1276.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1276-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1276-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1276-retro-min.jpg",
        "prod1": "ABITO ATHENA",
        "stile1": "PIZZO BIANCO",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1356.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1356-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1356-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1356-retro-min.jpg",
        "prod1": "TOP FABY",
        "stile1": "PIZZO BIANCO",
        "taglia1": "TAGLIA SML",

        "prod2": "PANTALONE RIESLING",
        "stile2": "BIANCO",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1379.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1379-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1379-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1379-retro-min.jpg",
        "prod1": "TOP FIANO",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA UNICA",

        "prod2": "PANTALONE KRUG",
        "stile2": "PIZZO SAN GALLO",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1312.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1312-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1312-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1312-retro-min.jpg",
        "prod1": "TOP BIANCA",
        "stile1": "PIZZO SAN GALLO",
        "taglia1": "TAGLIA XS/S-M/L",

        "prod2": "GONNA NEVE",
        "stile2": "PIZZO SAN GALLO",
        "taglia2": "TAGLIA UNICA",

        "colori": "+COLOUR"

    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1336.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1336-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1336-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1336-retro-min.jpg",
        "prod1": "ABITO AURORA",
        "stile1": "PIZZO SAN GALLO",
        "taglia1": "TAGLIA XS/S-M/L",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1604.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1604-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1604-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1604-retro-min.jpg",
        "prod1": "ABITO DOLCETTO",
        "stile1": "PIZZO JEANS",
        "taglia1": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1556.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1556-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1556-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1556-retro-min.jpg",
        "prod1": "CAMICIA PRIMITIVO",
        "stile1": "PIZZO JEANS",
        "taglia1": "TAGLIA UNICA",

        "prod2": "SHORT LINDO",
        "stile2": "PIZZO JEANS",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1584.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1584-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1584-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1584-retro-min.jpg",
        "prod1": "TURA ERCOLE",
        "stile1": "PIZZO JEANS",
        "taglia1": "TAGLIA XS/S-M/L",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1502.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1502-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1502-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1502-retro-min.jpg",
        "prod1": "ABITO ATHENA",
        "stile1": "PIZZO JEANS",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/4_antiqueLace/BLITZ POSITANO-1547.jpg",
        "retro": "lookbook1/4_antiqueLace/BLITZ POSITANO-1547-retro.jpg",
        "photomin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1547-min.jpg",
        "retromin": "lookbook1/4_antiqueLace/BLITZ POSITANO-1547-retro-min.jpg",
        "prod1": "ABITO CHABLIS",
        "stile1": "PIZZO JEANS",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    }
];
export const greenTouchProducts = [
    {
        "photo": "lookbook1/5_greenTouch/BLITZ POSITANO-1453.jpg",
        "retro": "lookbook1/5_greenTouch/BLITZ POSITANO-1453-retro.jpg",
        "photomin": "lookbook1/5_greenTouch/BLITZ POSITANO-1453-min.jpg",
        "retromin": "lookbook1/5_greenTouch/BLITZ POSITANO-1453-retro-min.jpg",
        "prod1": "COVER UP CUVEE",
        "stile1": "RICAMO GRECIA JEANS",
        "taglia1": "TAGLIA UNICA",

        "prod2": "SHORT LAMPONE",
        "stile2": "RICAMO GRECIA JEANS",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/5_greenTouch/BLITZ POSITANO-1467.jpg",
        "retro": "lookbook1/5_greenTouch/BLITZ POSITANO-1467-retro.jpg",
        "photomin": "lookbook1/5_greenTouch/BLITZ POSITANO-1467-min.jpg",
        "retromin": "lookbook1/5_greenTouch/BLITZ POSITANO-1467-retro-min.jpg",
        "prod1": "TOP FIANO",
        "stile1": "RICAMO GRECIA JEANS",
        "taglia1": "TAGLIA UNICA",

        "prod2": "GONNA GIN",
        "stile2": "RICAMO GRECIA JEANS",
        "taglia2": "TAGLIA UNICA",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/5_greenTouch/BLITZ POSITANO-1528.jpg",
        "retro": "lookbook1/5_greenTouch/BLITZ POSITANO-1528-retro.jpg",
        "photomin": "lookbook1/5_greenTouch/BLITZ POSITANO-1528-min.jpg",
        "retromin": "lookbook1/5_greenTouch/BLITZ POSITANO-1528-retro-min.jpg",
        "prod1": "ABITO BOURGOGNE",
        "stile1": "RICAMO GRECIA JEANS",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/5_greenTouch/BLITZ POSITANO-1416.jpg",
        "retro": "lookbook1/5_greenTouch/BLITZ POSITANO-1416-retro.jpg",
        "photomin": "lookbook1/5_greenTouch/BLITZ POSITANO-1416-min.jpg",
        "retromin": "lookbook1/5_greenTouch/BLITZ POSITANO-1416-retro-min.jpg",
        "prod1": "COVER UP CUVEE LUNGO",
        "stile1": "RICAMO GRECIA BIANCO",
        "taglia1": "TAGLIA UNICA",

        "prod2": "SHORT LAMPONE",
        "stile2": "RICAMO GRECIA BIANCO",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/5_greenTouch/BLITZ POSITANO-1444.jpg",
        "retro": "lookbook1/5_greenTouch/BLITZ POSITANO-1444-retro.jpg",
        "photomin": "lookbook1/5_greenTouch/BLITZ POSITANO-1444-min.jpg",
        "retromin": "lookbook1/5_greenTouch/BLITZ POSITANO-1444-retro-min.jpg",
        "prod1": "ABITO BOURGOGNE",
        "stile1": "RICAMO GRECIA BIANCO",
        "taglia1": "TAGLIA SML",

        "colori": "+COLOUR"
    },
    {
        "photo": "lookbook1/5_greenTouch/BLITZ POSITANO-1409.jpg",
        "retro": "lookbook1/5_greenTouch/BLITZ POSITANO-1409-retro.jpg",
        "photomin": "lookbook1/5_greenTouch/BLITZ POSITANO-1409-min.jpg",
        "retromin": "lookbook1/5_greenTouch/BLITZ POSITANO-1409-retro-min.jpg",
        "prod1": "TOP FIANO",
        "stile1": "BIANCO",
        "taglia1": "TAGLIA UNICA",

        "prod2": "GONNA GIN",
        "stile2": "RICAMO GRECIA BIANCO",
        "taglia2": "TAGLIA SML",

        "colori": "+COLOUR"
    }
];